import React from 'react';

import FilterWrapper from '../../../../components/Common/FilterWrapper';
import InputWrapper from '../../../../components/Common/InputWrapper';
import NowSelect from '../../../../components/Common/NowSelect';
import { trans } from '../../../../localization/index';
import FromToDatePicker from '../../../../components/Common/FromToDatePicker';
import { getPermissionRestaurant } from '../../../../utils/utils';
import { EnumMerchantPermission } from '../../../../constants/enum';

class ReportDishFilter extends React.Component {
  restaurantOptions = [
    {
      value: 0,
      label: trans('mod_all_restaurant'),
    },
    ...getPermissionRestaurant(
      this.props.restaurants,
      EnumMerchantPermission.REPORT_ALL.id,
    ).map(res => ({
      value: res.restaurant_id,
      label: res.is_use_partner_app ? (
        <div className="choose-restaurant-modal-option">
          {res.name}
          <div className="choose-restaurant-modal-option-tag">
            {trans('merchant_transfer_simpleDialog_text_transferred')}
          </div>
        </div>
      ) : res.name,
    }))
  ];

  handleChangeRestaurant = (value) => {
    const { filters, handleChangeFilters, handleSearch } = this.props;
    const { restaurant } = filters;
    if (value === null || value.value !== restaurant.value) {
      handleChangeFilters('restaurant', value);
      handleSearch();
    }
  };

  render() {
    const {
      filters,
      handleSearch,
      handleSearchToday,
      handleChangeFilters,
    } = this.props;
    const { restaurant, fromDate, toDate } = filters;
    return (
      <FilterWrapper>
        <InputWrapper label={trans('mod_restaurant_list')} width={300}>
          <NowSelect
            value={restaurant}
            options={this.restaurantOptions}
            onChange={this.handleChangeRestaurant}
          />
        </InputWrapper>
        <InputWrapper label={trans('mod_filter_time')} width={300}>
          <FromToDatePicker
            fromDate={fromDate}
            toDate={toDate}
            handleChangeFromDate={date => handleChangeFilters('fromDate', date)}
            handleChangeToDate={date => handleChangeFilters('toDate', date)}
          />
        </InputWrapper>
        <InputWrapper>
          <button
            type="button"
            className="btn btn-red mr-2"
            onClick={handleSearch}
          >
            {trans('mod_filter_search')}
          </button>
          <button
            type="button"
            className="btn btn-white"
            onClick={handleSearchToday}
          >
            {trans('mod_filter_today')}
          </button>
        </InputWrapper>
        <div className="group-btn-view mt-2" hidden>
          <button
            onClick={() => handleChangeFilters('isShowChart', false)}
            className="btn btn-view"
          >
            <i className="fas fa-table" />
          </button>
          <button
            onClick={() => handleChangeFilters('isShowChart', true)}
            className="btn btn-view"
          >
            <i className="fas fa-chart-bar" />
          </button>
        </div>
      </FilterWrapper>
    );
  }
}

export default ReportDishFilter;



// WEBPACK FOOTER //
// ./foody/src/pages/Order/ReportDish/components/ReportDishFilter.jsx